import * as request from '@/utils/request'
import config from '@/config/'

let api = config.baseUrl;

// 获取最近14天订单数据(散点图)
export const getPastDayReportData = (params) => request.get(api + `/v2/admin/report/summary/report/pastday`, params);

// 获取最近14天订单数据(按设备分开)
export const getPastDayEquipmentReportData = (params) => request.get(api + `/v2/admin/report/summary/equipment/report/pastday/`, params);

// 获取社区排名TOP10数据
export const getCommunityRankingData = (params) => request.get(api + `/v2/admin/report/get/community/rank`, params);
// 获取省份排行数据
export const getRegionalRankingData = (params) => request.get(api + `/v2/admin/report/get/province/rank`, params);
// 获取城市排行数据
export const getCityRankingData = (params) => request.get(api + `/v2/admin/report/get/city/rank`, params);
// 获取全局汇总数据
export const getTotalData = (params) => request.get(api + `/v2/admin/report/summary/base/total`, params);

// 获取按设备类型全局汇总数据
export const getEquipmentTotalData = (params) => request.get(api + `/v2/admin/report/summary/equipment/base/total`, params);

// 获取充值数据
export const getIncomeData = (params) => request.get(api + `/v2/admin/report/get/last/income`, params);
// 获取消费数据
export const getConsumeData = (params) => request.get(api + `/v2/admin/report/get/last/consume`, params);
// 获取过去周使用率
export const getUtilizationData = (params) => request.get(api + `/v2/admin/report/get/pastday/userate`, params);
// 获取设备异常信息
export const geTabnormalData = (params) => request.get(api + `/v2/admin/report/get/device/alarm`, params);

// 获取设备高温预警信息
export const getHtWarningData = (params) => request.get(api + `/v2/admin/report/get/device/ht/warning`, params);

// 运营商配置信息
export const getMerchantConfigData = (params) => request.get(api + `/v2/admin/report/get/merchant/map/config`, params);

// 地图数据(省份密度接口)
export const getMapData = (params) => request.get(api + `/v2/admin/report/get/all/province`, params);
// 地图数据()
export const getCityMapData = (params) => request.get(api + `/v2/admin/report/get/all/city`, params);

// 获取今日所有的充电订单
export const getTodayOrder = (params) => request.get(api+`/v1/admin/report/get/all/city`, params);

export const getPastDayUseRateList = (params) => request.get(api + `/v2/admin/report/get/day/userate/list`, params);

export const getRecentDayDistribute = (params) => request.get(api + `/v2/admin/report/get/recent/day/distribute`, params);

export const getCurrentTimeDistribute = (params) => request.get(api + `/v2/admin/report/get/current/time/distribute`, params);

export const getDayTimeCompareData = (params) => request.get(api + `/v2/admin/report/get/day/time/compare`, params);

export const getCarSocketDistributeData = (params) => request.get(api + `/v2/admin/report/get/car/socket/distribute`, params);

export const getBikeSocketDistributeData = (params) => request.get(api + `/v2/admin/report/get/bike/socket/distribute`, params);

export const getBikeChargingMethodDistributeData = (params) => request.get(api + `/v2/admin/report/get/bike/method/distribute`, params);

export const getRealTimeChargingDistributeData = (params) => request.get(api + `/v2/admin/report/get/real/time/charging/distribute`, params);

// 监控告警接口
export const getdeterminelist = (params) => request.get(api + `/v1/admin/monitor/alarm/message/list`, params);

// 摄像头
export const getrulelist = (params) => request.get(api + `/v1/test/camera/get/cameras`, params);
export const getruledetail = (params) => request.get(api + `/v1/test/camera/get/videoUrl`, params);

